import { render, staticRenderFns } from "./DataInputPage.vue?vue&type=template&id=35fd17c2&"
import script from "./DataInputPage.vue?vue&type=script&lang=ts&"
export * from "./DataInputPage.vue?vue&type=script&lang=ts&"
import style0 from "./DataInputPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports